module.exports = __webpack_public_path__ + "static/media/currency_rupee.f2afe9c5.svg";